module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('vue-simple-calendar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dayViewProps.viewingDay),
      expression: "!dayViewProps.viewingDay"
    }],
    staticClass: "theme-default",
    attrs: {
      "show-date": _vm.showDate,
      "events": _vm.displayPeriodUom === 'month' ? _vm.groupedEvents : _vm.events,
      "displayPeriodUom": _vm.displayPeriodUom,
      "eventContentHeight": "2em"
    },
    on: {
      "show-date-change": _vm.setShowDate,
      "click-date": _vm.selectDate,
      "click-event": _vm.selectEvent
    }
  }, [_c('v-layout', {
    staticClass: "cv-header",
    attrs: {
      "slot": "header",
      "wrap": ""
    },
    slot: "header"
  }, [_c('v-flex', {
    staticClass: "cv-header-nav",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-btn', {
    staticClass: "previousYear navButton",
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.previousYear
    }
  }, [_c('v-icon', [_vm._v("first_page")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "previousPeriod navButton",
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.previousPeriod
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "nextPeriod navButton",
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.nextPeriod
    }
  }, [_c('v-icon', [_vm._v("chevron_right")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "nextYear navButton",
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.nextYear
    }
  }, [_c('v-icon', [_vm._v("last_page")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "currentPeriod navButton",
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.today
    }
  }, [_c('v-icon', [_vm._v("today")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "periodLabel",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg7": ""
    }
  }, [_vm._v(_vm._s(_vm.dateLabel))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "offset-sm8": "",
      "md4": "",
      "offset-md0": "",
      "lg2": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "color": _vm.displayPeriodUom === 'week' ? 'primary' : 'grey lighten-1'
    },
    on: {
      "click": function($event) {
        _vm.displayPeriodUom = 'week'
      }
    }
  }, [_c('v-icon', [_vm._v("view_column")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "flat": "",
      "color": _vm.displayPeriodUom === 'month' ? 'primary' : 'grey lighten-1'
    },
    on: {
      "click": function($event) {
        _vm.displayPeriodUom = 'month'
      }
    }
  }, [_c('v-icon', [_vm._v("view_module")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-progress-linear', {
    staticStyle: {
      "margin": "5px 0px 0px 0px"
    },
    attrs: {
      "indeterminate": _vm.gettingEvents ? true : false,
      "color": _vm.gettingEvents ? 'primary' : 'secondary',
      "height": "2",
      "value": _vm.gettingEvents ? '' : 0
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('calendar-day-view', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dayViewProps.viewingDay),
      expression: "dayViewProps.viewingDay"
    }],
    attrs: {
      "templates": _vm.templates,
      "engineers": _vm.engineers,
      "customers": _vm.customers
    }
  }, 'calendar-day-view', _vm.dayViewProps, false, true))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a101d1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendar.vue
// module id = 735
// module chunks = 1